import { Stack, Table, Text } from '@mantine/core'
import React from 'react'
import { useTheme } from '../../../components/ThemeProvider'
import { useViewMode } from '../ViewModeProvider'
import InstitutionalApplicationRecordsChart from './InstitutionalApplicationRecordsChart'

interface InstitutionalApplicationRecordsProps {
  data: any
}

export default function InstitutionalApplicationRecords({ data }: InstitutionalApplicationRecordsProps) {
  const theme = useTheme()
  const { viewMode } = useViewMode()

  const categories = [
    { label: 'P2P', key: 'p2p' },
    { label: '网络小贷', key: 'xd' },
    { label: '消费分期', key: 'xffq' },
    { label: '现金分期', key: 'xjfq' },
    { label: '代偿分期', key: 'dcfq' },
    { label: '其他', key: 'qt' },
  ]

  const periods = [
    { label: '近7天', prefix: 'nb_d7' },
    { label: '近15天', prefix: 'nb_d15' },
    { label: '近1月', prefix: 'nb_m1' },
    { label: '近3月', prefix: 'nb_m3' },
    { label: '近6月', prefix: 'nb_m6' },
    { label: '近1年', prefix: 'nb_m12' },
  ]

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            机构类别拆分
          </Text>
          <Text size="xs" className="text-gray-500">
            展示非银机构的申请类别及涉及机构,识别是否集中在高风险品类。
          </Text>
        </div>
        {viewMode === 'table' ? (
          <>
            {periods.map((period) => (
              <div key={period.label} className="flex flex-col gap-2">
                <Text size="xs" fw={600} className="text-gray-600">
                  {period.label}
                </Text>
                <Table
                  highlightOnHover
                  withColumnBorders={false}
                  verticalSpacing="sm"
                  styles={{
                    table: { fontSize: '13px' },
                    th: {
                      backgroundColor: theme.surfaceMutedColor,
                      color: theme.accentTextColor,
                      whiteSpace: 'nowrap',
                    },
                  }}
                >
                  <Table.Thead>
                    <Table.Tr>
                      <Table.Th>机构类别</Table.Th>
                      <Table.Th>申请次数</Table.Th>
                      <Table.Th>申请机构数</Table.Th>
                    </Table.Tr>
                  </Table.Thead>
                  <Table.Tbody>
                    {categories.map((category) => {
                      const countKey = `${period.prefix}_apply_${category.key}_count`
                      const orgKey = `${period.prefix}_apply_${category.key}_org_count`
                      return (
                        <Table.Tr key={category.key}>
                          <Table.Td>{category.label}</Table.Td>
                          <Table.Td>{data?.[countKey] ?? 0}</Table.Td>
                          <Table.Td>{data?.[orgKey] ?? 0}</Table.Td>
                        </Table.Tr>
                      )
                    })}
                  </Table.Tbody>
                </Table>
              </div>
            ))}
          </>
        ) : (
          <InstitutionalApplicationRecordsChart data={data} />
        )}
      </Stack>
    </div>
  )
}
